import React from 'react';
import { FormAccess } from '../../services/apiSLTP/qhse/forms/formAccess';
import { FormTemplate } from '../../services/apiSLTP/qhse/forms/formTemplates';
import { getFormTemplateStatusColor } from '../../utils/colors';
import tinycolor from 'tinycolor2';
import { useTheme } from '../../hooks/useTheme';
import IconButton from '../shared/IconButton';
import { useBoolean } from '../../hooks/useBoolean';
import AddGroupFormAccessModal from '../modals/qhse/forms/AddGroupFormAccessModal';
import { capitalizeFirstLetter, formatName } from '../../utils/capitalize';
import { useTranslation } from 'react-i18next';

interface FormAccessCellProps {
    userId: string;
    userName: string;
    formAccesses: FormAccess[];
    forms: FormTemplate[];
    isPublic: boolean;
    refetch: () => void;
}

const FormAccessCell: React.FC<FormAccessCellProps> = ({ userId, userName, formAccesses, forms, isPublic, refetch }) => {
    const { muiTheme } = useTheme();
    const { t } = useTranslation();
    const addFormAccessModal = useBoolean(false);
    const userFormAccesses = formAccesses.filter((access) => access.userId === userId);
    return (
        <div className="fx-r">
            {!isPublic && <IconButton iconName="addCircle" title={capitalizeFirstLetter(t('addAccess'))} onClick={addFormAccessModal.setTrue} />}
            <div className="fx-c gap-5px pad-5px">
                {forms
                    .filter((form) => form.isPublic === isPublic)
                    .map((form) => {
                        if (!isPublic) {
                            const access = userFormAccesses.find((fa) => fa.groupId === form.groupId);
                            if (!access) return null;
                        }
                        return (
                            <div
                                key={form._id}
                                className="border-radius-10px pad-5px"
                                style={{
                                    backgroundColor: getFormTemplateStatusColor(form.status),
                                    color: tinycolor(getFormTemplateStatusColor(form.status)).isDark()
                                        ? muiTheme.palette.common.white
                                        : muiTheme.palette.common.black,
                                }}
                            >
                                {form.title}
                            </div>
                        );
                    })}
            </div>
            {addFormAccessModal.value && (
                <AddGroupFormAccessModal
                    open={addFormAccessModal.value}
                    handleClose={addFormAccessModal.setFalse}
                    userId={userId}
                    userName={userName}
                    refetch={refetch}
                    forms={forms}
                />
            )}
        </div>
    );
};

export default FormAccessCell;
